import { AUTH_ENABLED } from './AuthConfig';
import { supabase } from './SupabaseClient';

export async function retrieveAccessToken({ required = AUTH_ENABLED } = {}) {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();

    if (sessionError) {
        throw new Error(`Failed to get session: ${sessionError.message}`);
    }

    // Use the access token from the current session
    const accessToken = session?.access_token;

    if (required && !accessToken) {
        throw new Error("No authentication token available");
    }
    return accessToken;
} 